import React from 'react';
import { AttributesT } from '../../../utils/constants';
import productStyle from './../Product.module.scss';
import { StandardItem } from '../../StandardItem/StandardItem';
import { useAttribute } from '@threekit-tools/treble/dist';
import { useStoreSelector } from '../../..';
import { getActualPriceById } from '../../../store/selectors/selectors';
import { getProductParameters } from '../Product';
import { moveNoneToFirstPosition, NoImage } from '../../../utils/helpFunctions';

export const HoodCatcher = ({ ...props }) => {
  const name: AttributesT = props.name;
  const [attribute, setAttribute]: any = useAttribute(name);
  const attributeInfo = useStoreSelector(getActualPriceById);
  const NotImage = NoImage();
  const allAttributes = moveNoneToFirstPosition(attribute.values);

  return (
    <div
      className={productStyle.product__wrapper}
      style={{
        width: `${80 * attribute.values.length}px`,
      }}
    >
      {allAttributes.map((item: any, index: number) => {
        const isAsset = attribute.type === 'Asset';
        let label = item.label;
        let priceInfo: any;

        if (isAsset && label !== 'None') {
          const id = item.metadata._id;
          priceInfo = attributeInfo[id];
        }
        const data = getProductParameters({
          item,
          attribute,
          setAttribute,
          priceInfo,
          hintPosition: 'bottom',
          NotImage,
          name,
        });

        return <StandardItem {...data} key={`${item.value}-${index}`} />;
      })}
    </div>
  );
};
